/**
 * Nutrition panel behaviour for the advertorial.
 *
 * The panel's CSS already ships site-wide (it lives in a stylesheet block inside
 * sections/mimu-nutrition-panel.liquid, which compiles into the global
 * compiled_assets/styles.css), but that section's init script is inline and only
 * runs on pages where the section renders. This is a standalone copy for the
 * advertorial.
 *
 * It uses the same data attributes and the same :not([data-mimu-nutri-ready])
 * guard, so if both ever ran on one page neither would double-initialise.
 */
(function () {
  function init() {
    var roots = document.querySelectorAll('[data-mimu-nutri]:not([data-mimu-nutri-ready])');

    Array.prototype.forEach.call(roots, function (root) {
      root.setAttribute('data-mimu-nutri-ready', '');

      var head = root.querySelector('[data-mimu-nutri-toggle]');
      var body = root.querySelector('[data-mimu-nutri-body]');
      var tiles = root.querySelectorAll('[data-mimu-nutri-tile]');
      var panels = root.querySelectorAll('[data-mimu-nutri-panel]');

      function show(index) {
        Array.prototype.forEach.call(panels, function (panel) {
          panel.hidden = panel.getAttribute('data-mimu-nutri-panel') !== index;
        });
        Array.prototype.forEach.call(tiles, function (tile) {
          tile.setAttribute(
            'aria-expanded',
            tile.getAttribute('data-mimu-nutri-tile') === index ? 'true' : 'false'
          );
        });
      }

      if (head && body && !head.disabled) {
        head.addEventListener('click', function () {
          var open = head.getAttribute('aria-expanded') === 'true';
          head.setAttribute('aria-expanded', open ? 'false' : 'true');
          body.hidden = open;
        });
      }

      // Matches the section version: opens itself once when scrolled into view.
      // No-op while this panel is already open by default, but keeps the two
      // implementations behaving the same if that setting is ever turned off.
      if (head && body && !head.disabled) {
        var autoOpened = false;

        var autoOpen = function () {
          if (autoOpened) return;
          autoOpened = true;
          if (head.getAttribute('aria-expanded') === 'true') return;
          head.setAttribute('aria-expanded', 'true');
          body.hidden = false;
        };

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                io.disconnect();
                autoOpen();
                return;
              }
            }
          }, { threshold: 0.25 });
          io.observe(root);
        } else {
          autoOpen();
        }
      }

      Array.prototype.forEach.call(tiles, function (tile) {
        tile.addEventListener('click', function () {
          var index = tile.getAttribute('data-mimu-nutri-tile');
          // Tapping the open flavour closes it again.
          var already = tile.getAttribute('aria-expanded') === 'true';
          show(already ? null : index);
        });
      });
    });
  }

  init();
  // Theme editor re-renders blocks without a page load.
  document.addEventListener('shopify:section:load', init);
})();
